import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { awardBg } from "../../../assets/images";
import AOS from "aos";
import "aos/dist/aos.css";

const Awards = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: false,
      offset: 300,
    });
  }, []);

  return (
    <div
      data-aos="fade-up"
      className="mt-[56px] md:mt-[88px] overflow-x-hidden max-w-containerSm md:max-w-container mx-auto"
    >
      <p className="text-[28px] md:text-[40px] font-medium text-[#2a3d63] text-center mb-8">
        {t("Cortex Construction – Keyfiyyət və etibarın adı!")}
      </p>

      {/* Background image container */}
      <div
        className="relative w-full h-[400px] md:h-[342px] bg-cover bg-center flex justify-center"
        style={{ backgroundImage: `url(${awardBg})` }}
      >
        {/* Green div */}
        <div className="absolute bottom-0 translate-y-1/2 py-4 px-6 w-[80%] border border-[#E5E5E5] bg-[white] rounded-xl md:h-[180px] gap-[180px] md:flex items-center justify-center">
          <div className="text-center">
            <p className="text-[20px] md:text-[24px] font-medium">
           30+
          </p>
          <p className="text-[24px] md:text-[28px] font-medium">
           {t("Uğurlu layihə")}
          </p>
          </div>
             <div className="text-center">
            <p className="text-[20px] md:text-[24px] font-medium">
           35+
          </p>
          <p className="text-[24px] md:text-[28px] font-medium">
           {t("Müştəri Razılığı")}
          </p>
          </div>
            <div className="text-center">
            <p className="text-[20px] md:text-[24px] font-medium">
           30+
          </p>
          <p className="text-[24px] md:text-[28px] font-medium">
        {t("Personal")}
          </p>
          </div>
        </div>
      </div>

      {/* boşluq – altda content üst-üstə düşməsin */}
      <div className="h-[100px]" />
    </div>
  );
};

export default Awards;
